
import request from '@/utils/request'

// 查询充值记录
export function fetchList (data) {
  return request.post('/system/TRTC/getCallLog',data)
}